var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOjocerrado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1306_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 15.4988C13.6566 15.4988 14.9992 14.1561 14.9992 12.4999C14.9992 10.8437 13.6566 9.50104 12.0003 9.50104C10.3441 9.50104 9.00146 10.8437 9.00146 12.4999C9.00146 14.1561 10.3441 15.4988 12.0003 15.4988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4501 10.5649C19.2873 8.67111 16.6423 5.49377 12 5.49377C7.35771 5.49377 4.71269 8.67111 3.54987 10.5649C2.81671 11.7507 2.81671 13.2491 3.54987 14.435C4.71269 16.3288 7.35771 19.5061 12 19.5061C16.6423 19.5061 19.2873 16.3288 20.4501 14.435C21.1833 13.2491 21.1833 11.7507 20.4501 10.5649ZM12 16.9983C9.51564 16.9983 7.50165 14.9843 7.50165 12.4999C7.50165 10.0156 9.51564 8.00159 12 8.00159C14.4843 8.00159 16.4983 10.0156 16.4983 12.4999C16.4958 14.9832 14.4833 16.9958 12 16.9983Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1306_394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjocerrado);
export default __webpack_public_path__ + "static/media/ojocerrado.4d947fe24eff79aa77854869bc23b7be.svg";
export { ForwardRef as ReactComponent };